import React from 'react';

const Panel = (props) => {

    return (
        <div id={props.id} style={{background: "rgb(249, 249, 252)"}} className={`kt-offcanvas-panel ${props.open ? "kt-offcanvas-panel--on" : ""}`}>
            {props.children}
        </div>
    );
}

export default Panel;